export default __webpack_public_path__ + "static/chart-desktop-7953a5b5d39523e8fe8f30b2080011c9.webp";